import React, { useState } from "react";
import SocialMedia from "../common/SocialMedia";

export default function ContactBand() {
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");

    const YOUR_EMAIL = "info@scaldcoffee.com";
    const YOUR_PHONE = "+90 545 956 31 45";

    const handleSubmit = (e) => {
        e.preventDefault();

        const subject = encodeURIComponent("Web sitesi iletişim");
        const body = encodeURIComponent(
            `Gönderen E-posta: ${email}\n\nMesaj:\n${message}`
        );

        window.location.href = `mailto:${YOUR_EMAIL}?subject=${subject}&body=${body}`;
    };

    return (
        <div>
            <section id="contact" className="contactBand">
                <div className="container contactBandGrid">
                    <div className="contactBandLeft">
                        <h3 className="contactBandTitle">Bize Ulaşın</h3>
                        <p className="contactBandDesc">
                            E-postanızı ve mesajınızı yazın, tek tıkla bize iletin.
                        </p>

                        <form className="contactForm" onSubmit={handleSubmit}>
                            <label className="contactLabel">
                                E-posta
                                <input
                                    className="contactInput"
                                    type="email"
                                    placeholder="ornek@mail.com"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                            </label>

                            <label className="contactLabel">
                                Mesaj
                                <textarea
                                    className="contactTextarea"
                                    placeholder="Mesajınızı yazın..."
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                    required
                                    rows={4}
                                />
                            </label>

                            <button className="contactBtn" type="submit">
                                Gönder
                            </button>
                        </form>
                    </div>

                    <div className="contactBandRight">
                        <div className="phoneBox">
                            <div className="phoneIcon" aria-hidden="true">☎</div>
                            <div>
                                <div className="phoneLabel">Telefon</div>
                                <a className="phoneNumber" href={`tel:${YOUR_PHONE.replace(/\s/g, "")}`}>
                                    {YOUR_PHONE}
                                </a>
                                <div className="phoneHint">Hızlı bilgi için arayabilirsiniz.</div>
                            </div>
                        </div>
                    </div>
                </div>

            </section>
            <div className="contactSocialBar">
                <div className="container">
                    <SocialMedia variant="bar" />
                </div>
            </div>
        </div>

    );
}
